import React from 'react';
import { useIntl } from 'react-intl';
import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo';
import { StreamingShortVideoResponse } from 'fym-shared/src/music24/streamingSections';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { useStreamingPeriod } from '../../hooks/useStreamingPeriod';
import { formatDay } from '../../streamingFormat';
import { shortVideoMessages as messages } from '../../shortVideoMessages';
import { streamingPeriodMessages } from '../../streamingPeriodMessages';
import { SectionNoneCard } from '../../period/SectionNoneCard';
import { UGC_PLATFORM_LOOKS } from './ugcPlatforms';

interface ShortVideoNoneProps {
  answer: StreamingShortVideoResponse;
  sourceName: string;
  days: number;
  onShowAll: () => void;
}

/**
 * No videos in the period (design streaming-sections c2): for the picked platform ("Show all
 * platforms"), or for every platform ("Pick 90 days").
 */
const ShortVideoNoneComponent: React.FC<ShortVideoNoneProps> = ({ answer, sourceName, days, onShowAll }) => {
  const intl = useIntl();
  const period = useStreamingPeriod();
  const start = formatDay(intl, answer.range.from);
  const end = formatDay(intl, answer.range.to);

  if (answer.platform !== null) {
    const platform = UGC_PLATFORM_LOOKS[answer.platform].shortName;
    return (
      <SectionNoneCard
        icon={faVideo}
        testId="streaming-shortVideo-none-platform"
        title={intl.formatMessage(messages.noPlatformTitle, { platform, start, end })}
        text={intl.formatMessage(messages.noPlatformText, { source: sourceName, platform })}
      >
        <SMLButton variant="primary" onClick={onShowAll}>
          {intl.formatMessage(messages.showAllPlatforms)}
        </SMLButton>
      </SectionNoneCard>
    );
  }
  return (
    <SectionNoneCard
      icon={faVideo}
      testId="streaming-shortVideo-none"
      title={intl.formatMessage(messages.noVideosTitle, { start, end })}
      text={intl.formatMessage(messages.noVideosText, { source: sourceName })}
    >
      {days < 90 ? (
        <SMLButton variant="primary" onClick={() => period.setDays(90)}>
          {intl.formatMessage(streamingPeriodMessages.pickDays, { days: 90 })}
        </SMLButton>
      ) : undefined}
    </SectionNoneCard>
  );
};

export const ShortVideoNone = TypedMemo(ShortVideoNoneComponent);
